export type ReportCategory =
    | 'Online Sales'
    | 'POS Sales'
    | 'Ticket Scanning'
    | 'Marketing'
    | 'Attendees'
    | 'Accounting'
    | 'Reviews'
    | 'Event Summary';

export type ReportDefinition = {
    id: string;
    title: string;
    description: string;
    category: ReportCategory;
    viewedLabel?: string;
    hasTable: boolean;
    isFavourite?: boolean;
    sharedWithTeam?: boolean;
};

export type ReportSection = {
    id: string;
    title: string;
    reports: ReportDefinition[];
};

export const defaultReportId = 'online-orders';
export const FAVORITES_SECTION_ID = 'favorites';

export function findReportById(
    sections: ReportSection[],
    reportId: string,
): ReportDefinition | undefined {
    for (const section of sections) {
        const report = section.reports.find((item) => item.id === reportId);
        if (report) {
            return report;
        }
    }
    return undefined;
}

export function getAllReports(sections: ReportSection[]): ReportDefinition[] {
    return sections.flatMap((section) => section.reports);
}

export function buildReportLibrarySections(
    sections: ReportSection[],
    favoriteReportIds: string[],
): ReportSection[] {
    const allReports = getAllReports(sections);
    const favoriteReports = favoriteReportIds
        .map((id) => allReports.find((report) => report.id === id))
        .filter((report): report is ReportDefinition => report !== undefined)
        .map((report) => ({ ...report, isFavourite: true }));

    const enrichedSections = sections.map((section) => ({
        ...section,
        reports: section.reports.map((report) => ({
            ...report,
            isFavourite: favoriteReportIds.includes(report.id),
        })),
    }));

    if (favoriteReports.length === 0) {
        return enrichedSections;
    }

    return [
        {
            id: FAVORITES_SECTION_ID,
            title: 'Favorites',
            reports: favoriteReports,
        },
        ...enrichedSections,
    ];
}
